module.exports = __webpack_public_path__ + "img/帮助.1380e206.png";